import DataAnalysis from "../../../../src/pages/use-cases/page-content/content-and-data-extraction/data-analysis.md";
import * as React from 'react';
export default {
  DataAnalysis,
  React
};